import { RestServiceBase } from "@ane/core/lib/services/RestServiceBase";
class HostResources extends RestServiceBase {
  constructor() {
    super({ url: window.location.origin, tokenScope: "" });
  }
  setIsAne() {
    const address = `/setIsAne.aspx`;
    this._post(null, address);
  }
}
const HostResource = new HostResources();
export {
  HostResource as default
};
//# sourceMappingURL=Host.resource.js.map
